import { CARREGAR_EMPREENDIMENTOS_SUCESSO } from '../actions/actionTypes';
import initialState from './initialState.reducer';
import { empreendimentosParaSelect } from '../mapeadores/Empreendimentos/index';

export default (state = initialState.empreendimentos, action) => {
  if (action.type === CARREGAR_EMPREENDIMENTOS_SUCESSO)
    return empreendimentosParaSelect(action.empreendimentos);

  return state;
};